import { render, staticRenderFns } from "./confDialog.vue?vue&type=template&id=edca457e&"
import script from "./confDialog.vue?vue&type=script&lang=js&"
export * from "./confDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports